import { dateTimeParse } from "@gravity-ui/date-utils";
export const presetsForDatePicker = {
    today: {
        label: "Сегодня",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                return {
                    start: today.startOf("day"),
                    end: today.endOf("day"),
                };
            }
        },
    },
    currentWeek: {
        label: "Текущая неделя",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                return {
                    start: today.startOf("week"),
                    end: today.endOf("week"),
                };
            }
        },
    },
    currentMonth: {
        label: "Текущий месяц",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                return {
                    start: today.startOf("month"),
                    end: today.endOf("month"),
                };
            }
        },
    },
    lastWeek: {
        label: "Прошлая неделя",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                const lastWeek = today.subtract({ weeks: 1 });
                return {
                    start: lastWeek.startOf("week"),
                    end: lastWeek.endOf("week"),
                };
            }
        },
    },
    lastMonth: {
        label: "Прошлый месяц",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                const lastMonth = today.subtract({ months: 1 });
                return {
                    start: lastMonth.startOf("month"),
                    end: lastMonth.endOf("month"),
                };
            }
        },
    },
    nextMonth: {
        label: "Следующий месяц",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                const nextMonth = today.add({ months: 1 });
                return {
                    start: nextMonth.startOf("month"),
                    end: nextMonth.endOf("month"),
                };
            }
        },
    },
    nextWeek: {
        label: "Следующая неделя",
        getRange: () => {
            const today = dateTimeParse(new Date());
            if (today) {
                const nextWeek = today.add({ weeks: 1 });
                return {
                    start: nextWeek.startOf("week"),
                    end: nextWeek.endOf("week"),
                };
            }
        },
    },
};
